module.exports = __webpack_public_path__ + "img/02-top-img@2x.6cdd5072.png";